














import Vue from 'vue'
import mixins from 'vue-typed-mixins'

import ElementMixin from './ElementMixin'

export default mixins(ElementMixin).extend({
  computed: {
    months: {
      get(): number {
        return this.internalMonths
      },
      set(value: number): void {
        if (value < 0) {
          this.internalMonths = 11
          this.years = Math.max(this.years - 1, 0)
        } else {
          this.internalMonths = value % 12
          this.years = this.years + Math.floor(value / 12)
        }
      },
    },
    total(): number {
      return this.years * 12 + this.months
    },
  },
  created() {
    if (this.value == null || this.variable == null || this.value[this.variable] == null) {
      this.months = 0
    } else if (typeof this.value[this.variable] !== 'number') {
      throw new Error(`Months.vue expects an integer, not ${this.value[this.variable]}`)
    } else {
      this.months = this.value[this.variable]
    }
  },
  data() {
    return {
      internalMonths: 0,
      years: 0,
    }
  },
  watch: {
    total(newValue: number) {
      this.value[this.variable] = newValue
      this.$emit('input', this.value)
    },
  },
})
